// CRO-38 — promo code placement A/B. WebTrends calls one of:
//   window.duskMiniBagPromo.top() / .footer() / .off() / .reset()
// Stored for the session because the mini-bag is on every page.

(function () {
  'use strict';

  var STORAGE_KEY = 'duskMiniBagPromo';
  var CLASSES = { top: 'mini-bag-promo-top', footer: 'mini-bag-promo-footer' };

  function apply(arm) {
    var root = document.documentElement;
    Object.keys(CLASSES).forEach(function (key) {
      root.classList.toggle(CLASSES[key], key === arm);
    });
  }

  function store(arm) {
    try {
      if (arm === null) {
        sessionStorage.removeItem(STORAGE_KEY);
      } else {
        sessionStorage.setItem(STORAGE_KEY, arm);
      }
    } catch (e) {
      // Private mode.
    }
  }

  function setState(arm) {
    apply(arm);
    store(arm);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'mini_bag_promo_arm',
      mini_bag_promo_arm: arm === null ? 'default' : arm,
    });
  }

  try {
    var stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored && CLASSES[stored]) apply(stored);
  } catch (e) {}

  window.duskMiniBagPromo = {
    top: function () { setState('top'); },
    footer: function () { setState('footer'); },
    off: function () { setState('off'); },
    reset: function () { setState(null); },
  };
})();
